import { createSlice } from "@reduxjs/toolkit";

export const EquipamentActions = createSlice({
  name: "Equipaments",
  initialState: {
    value: {
        equip: [],
        ticket: [],
    },
  },
  
  reducers: {
       
    updateEquipment(state, { payload }) {
      state.value.equip = payload;
      console.log("equipments length " + state.value.equip.Propostas.length);
    },

    updateTicket(state, { payload }) {
      state.value.ticket = payload;
      console.log("updateTicket " + state.value.ticket.length);
    },
  },
});

export const {
  updateEquipment,
  updateTicket,
} = EquipamentActions.actions;

export default EquipamentActions.reducer;
